import React from 'react'
import * as yup from 'yup'
import { Formik } from 'formik'
import RadioButtonList from '../../../ui/radioButton'
import { Title, Text2, Text1 } from '../../../ui/text'
import { ChevronLeft } from '../../../../assets/icons'
import theme from '../../../../styled/theme'
import useIsMobile from '../../../../hooks/useIsMobile'
import {
	Container,
	TopInfoContainer,
	StyledForm,
	TextAreaContainer,
	Comments,
	TextWrapper,
	NextButton,
	NextButtonContainer,
	BackButton,
} from './styled'

const ReasonsScreen = ({ info, handleSubmit, historyIdHandler, hideBackButton, showExperienceTitle }) => {
	const isMobile = useIsMobile()

	const initialValues = {
		questionId: info.id,
		answerMode: 'multipleSelection',
		answerId: '',
		answerDescription: null,
		comment: '',
		nextQuestionId: undefined
	}

	const validationSchema = yup.object().shape({
		answerId: yup.string().required('Campo requerido'),
		comment: yup.string().max(150, 'Máximo 150 caracteres').when('answerId', {
			is: answerId => Boolean(info.answers.find(({ id }) => id === Number(answerId))?.extraField),
			then: schema => schema.required('Campo requerido')
		})
	})

	const findPlaceholder = (options, answerId) =>
		options.find(({ id }) => id === Number(answerId))?.placeholder ?? 'Deja tus comentarios'

	return (
		<Container>
			<TopInfoContainer>
				{!hideBackButton && (
					<BackButton onClick={() => historyIdHandler()}>
						<ChevronLeft
							size={16}
							color={isMobile ? theme.colors.text.secondaryText : theme.colors.brand.blueOmint}
						/>
						{!isMobile && <Text2 size="14px" color={theme.colors.brand.blueOmint}>Volver</Text2>}
					</BackButton>
				)}
				<Title
					as="h3"
					size="18px"
					mobileSize="18px"
					margin="0 0 10px 0"
					color={theme.colors.text.primaryText}
				>
					{info.description}
				</Title>
			</TopInfoContainer>
			<Formik onSubmit={handleSubmit} initialValues={initialValues} validationSchema={validationSchema}>
				{({ values, setFieldValue }) => {
					const selectedAnswer = info.answers.find(
						answer => answer.id.toString() === values.answerId
					)
					const hasExtraField = info.answers.some(answer => answer.extraField)
					const commentRequired = Boolean(selectedAnswer?.extraField)

					return (
						<StyledForm>
							<RadioButtonList
								options={info.answers.map(answer => ({
									id: answer.id.toString(),
									label: answer.description
								}))}
								selected={values.answerId}
								onChange={id => {
									const answer = info.answers.find(a => a.id.toString() === id)
									setFieldValue('answerId', id)
									setFieldValue('nextQuestionId', answer?.nextQuestionId)
								}}
								maxWidth="350px"
							/>
							{hasExtraField && (
								<TextAreaContainer>
									<Text2 size="16px" fontWeight={400} color={theme.colors.text.primaryText}>
										¿Qué sucedió?
									</Text2>
									<Comments
										name="comment"
										value={values.comment}
										onChange={event => setFieldValue('comment', event.target.value)}
										maxLength="150"
										placeholder={findPlaceholder(info.answers, values.answerId)}
									/>
									<TextWrapper>
										<Text2 size="14px" italic margin="4px 0 0 0" color={theme.colors.text.secondaryText}>
											(máx. 150 caracteres)
										</Text2>
									</TextWrapper>
								</TextAreaContainer>
							)}
							<NextButtonContainer>
								<NextButton
									disabled={
										!selectedAnswer || (commentRequired && !values.comment.trim())
									}
									type="submit"
									label={selectedAnswer ? 'Continuar' : 'Siguiente'}
								/>
							</NextButtonContainer>
						</StyledForm>
					)
				}}
			</Formik>
		</Container>
	)
}

export default ReasonsScreen
